import { APP_CONFIG } from "../constants/constants";

export const routeVariables = {
  invitationToken: "invitationToken",
  customEnv: "customEnv",
  authCode: "authCode",

  vehicleMap: {
    vehicleId: "vehicleId",
    filterTimestampStart: "filterTimestampStart",
    filterTimestampEnd: "filterTimestampEnd",
    buzzerAlertTimestamp: "buzzerAlertTimestamp",
    buzzerAlertId: "buzzerAlertId",
  },

  camera: {
    deviceEventId: "deviceEventId",
  },
};

export const routeUrls = {
  landingPage: "/",
  landingPageToSetCustomEnv: `/custom-env/:${routeVariables.customEnv}`, // used to set custom env using the localStorageKeys.TEMP_API_SERVER value
  loginPage: "/", // This is the same as the landing page
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  select2FAMethod: "/select-2fa-method",
  verify2FA: "/verify-2fa",

  authenticate: `/authenticate/:${routeVariables.authCode}`,

  authAzureCallback: APP_CONFIG.AZURE_AD.REDIRECT_URI,
  azureLogoutCallback: APP_CONFIG.AZURE_AD.LOGOUT,

  organizationInvitation: `/support/invitation/:${routeVariables.invitationToken}`, // this link is sent to the user's email

  termsAndConditions: "/terms-and-conditions",
  privacyPolicy: "/privacy-policy",

  changePassword: "/change-password",
  dashboard: "/dashboard",
  dashboardChildren: {
    overview: "/dashboard/overview",

    //admins
    admins: "/dashboard/admins",
    adminChildren: {
      // following values are being used dynamically to render 'Admins' dropdown on the dashboard header, thus, add / remove with caution
      users: "/dashboard/admins/users", // additionally being used with details route (:userId)
      roles: "/dashboard/admins/roles",
      manage_rule_alert: "/dashboard/admins/rules-alerts",
      vehicles: "/dashboard/admins/assets", // additionally being used with details route (:vehicleId)
      groups: "/dashboard/admins/groups",
      fleettags: "/dashboard/admins/fleet-tags",
      drivers: "/dashboard/admins/drivers",
      geozones: "/dashboard/admins/geozones",
      geozoneCategories: "/dashboard/admins/geozone-categories",
      // maintenance: "/dashboard/admins/maintenance",
      documents: "/dashboard/admins/documents",
      importExport: "/dashboard/admins/import-export",
      standardIcons: "/dashboard/admins/import-export/standard-listing",
      customIcons: "/dashboard/admins/import-export/custom-listing",
      heatmap: "/dashboard/admins/heatmap",
      eventColors: "/dashboard/admins/event-colors",
      incidentReview: "/dashboard/admins/incident-review",
      inCabCoaching: "/dashboard/admins/incab-coaching"
    },

    // maps
    maps: "/dashboard/maps",
    managedAccounts: "/dashboard/managed-accounts",
    managedAccountUsers: "/dashboard/managed-accounts/account-users/:accountId",
    mapsChildren: {
      fleet: "/dashboard/maps/fleet",
      heat: "/dashboard/maps/heat",
      multiVehicle: "/dashboard/maps/multi-vehicle",
      vehicle: "/dashboard/maps/asset",
      getVehicleMapUri: (
        vehicleId: string,
        filterTimestampStart: string | number,
        filterTimestampEnd: string | number,
        buzzerAlertTimestamp?: string | number,
        buzzerAlertId?: number
      ) =>
        `/dashboard/maps/asset/${vehicleId}/${filterTimestampStart}/${filterTimestampEnd}` +
        `${!!buzzerAlertTimestamp && !!buzzerAlertId ? `/${buzzerAlertTimestamp}/${buzzerAlertId}` : ""}`,
    },

    // reports
    reports: "/dashboard/reports",
    reportsChildren: {
      select_a_type: "/dashboard/reports/select-a-type",

      reportPrefix: "/dashboard/reports", // several parameters are passed to this route
      reportSuffixParamsUri:
        "/type/:reportType/category/:categoryId/report/:reportId/:reportFilters",
      reportSuffixParamsUriFiltersOptional:
        "/type/:reportType/category/:categoryId/report/:reportId/",
      reportSharingSuffixUri:
        "/manage-sharing/type/:reportType/category/:categoryId/report/:reportId/",
    },
    incident_review: "/dashboard/incident-review",
    incident_review_detail: "/dashboard/incident-review/detail",

    // more admin pages
    manage_roles: "/dashboard/manage-roles",
    maintenance: "/dashboard/maintenance",
    vehicle_alert: "/dashboard/asset-alert",
    panic_alert: "/dashboard/panic-alert",
    whiteLabel: "/dashboard/whitelabel",
    whiteLabelChildren: {
      whitelabel_settings: "/dashboard/whitelabel/settings",
      add_new: "/dashboard/whitelabel/add-new",
    },

    camera_admin: "/dashboard/camera-admin",
    cameraChildren: {
      dashboard: "/dashboard/camera-admin/dashboard",

      events: "/dashboard/camera-admin/events",
      recordings: "/dashboard/camera-admin/recordings",

      video_playback: "/dashboard/camera-admin/video-playback",
      camera_settings: "/dashboard/camera-admin/camera-settings",
      sensor_event_detection: "/dashboard/camera-admin/sensor-event-detection",
      ai_event_detection_adas: "/dashboard/camera-admin/ai-event-detection-adas",
      ai_event_detection_dms: "/dashboard/camera-admin/ai-event-detection-dms",
      traffic_signal_detection:
        "/dashboard/camera-admin/traffic-signal-detection",

      camera_management: "/dashboard/camera-admin/camera-management",
      camera_overview: "/dashboard/camera-admin/camera-overview/:cameraId/",
    },
    compliance_admin: "/dashboard/compliance-admin",

    //profile
    account: "/dashboard/account",

    // help section
    help: "/dashboard/help",

    // user manual section
    user_manual: "/dashboard/user-manual",

    // chat section
    chat: "/dashboard/chat",

    // crash track
    crashTrack: "/dashboard/crash-reconstruction",
  },

  sysadmin: "/sysadmin",
  sysadminChildren: {
    enterprises: "/sysadmin/enterprises",
    account_users: "/sysadmin/enterprises/account-users/:accountId",
  },
};
